exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fixed-fee-entries-table[data-v-822ea90c] tbody .v-selection-control--dirty .v-icon {\n  color: rgb(67, 160, 71) !important;\n}\n.fixed-fee-entries-table[data-v-822ea90c] thead .v-selection-control--dirty .v-icon {\n  color: rgb(67, 160, 71) !important;\n}\n\n/* Custom accordion header button styling */\n.time-entries-accordion button[data-v-822ea90c]:focus {\n  outline: none;\n}\n", ""]);

// exports
